import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { placeOrder } from '../../queries/stripe.graphql.js';
import { altapayQuote } from '../../queries/altapay.graphql.js';
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useSendMessage } from 'crustate/react';
import { addMessage } from '@crossroads/shop-state/messages';
import { syncQuote } from '@crossroads/shop-state/quote';
import { Wrapper, Dialogue } from '@crossroads/ui-components';
import { parseParams } from '../../helpers/location-search-string.js';
import { syncCustomer } from '@crossroads/shop-state/customer';
import { rules, isRequired, Form } from '@awardit/formaggio';
import cn from 'classnames';
import { Box, BoxHeader, BoxBody } from '../../components/Box/index.js';
import { Button } from '../../components/Button/index.js';
import { CrossSvg } from '../../icons/index.js';
import { CheckboxField } from '../../components/Field/index.js';
import styles from 'shop-views/Checkout.scss';
import { OrderSummary } from '../../components/OrderSummary/index.js';
import { CustomerForm } from '../../components/CustomerForm/index.js';
import { HandleAltapayRedirect } from '../../components/HandleAltapayRedirect/index.js';
import { PaymentMethods } from '../../components/PaymentMethods/Altapay/index.js';
import { PartPayment } from '../../components/PartPayment/index.js';
import { useTranslate } from '@awardit/react-use-translate';
import useBrowserDimensions from '../../helpers/use-browser-dimensions.js';
import { ProceedToPayment } from '../../components/ProceedToPayment/index.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var validation = rules([isRequired("terms")]);

function _empty() {}

var RenderTerms = _ref => {
  var state = _ref.state,
      agreement = _ref.agreement;
  var t = useTranslate();

  var _useState = useState(false),
      showTerms = _useState[0],
      setShowTerms = _useState[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modalWrapper
  }, /*#__PURE__*/React.createElement(Dialogue, {
    className: styles.modal,
    open: showTerms,
    setOpen: () => setShowTerms(false)
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles.close_button,
    onClick: () => setShowTerms(false)
  }, /*#__PURE__*/React.createElement("img", {
    src: CrossSvg
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.termsWrapper
  }, agreement))), /*#__PURE__*/React.createElement("div", {
    className: styles.terms
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    name: "terms",
    value: state.terms
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.text
  }, t("CHECKOUT.I_ACCEPT_THE"), " "), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: cn(styles.link),
    size: "small",
    onClick: e => {
      e.preventDefault();
      setShowTerms(true);
    }
  }, t("CHECKOUT.TERMS")), "*")));
};

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var Checkout = _ref2 => {
  var _quoteData$data, _quoteData$data$payme, _quoteData$data3, _addressIsValid;

  function _temp4() {
    setIsPending(false);
    push(t("URL.CHECKOUT_SUCCESS"));
  }

  function _temp3() {
    if (customerQuery !== null && customerQuery !== undefined) {
      return _awaitIgnored(client(customerQuery).then(_temp2));
    }
  }

  function _temp2(_ref4) {
    var customer = _ref4.customer;
    sendMessage(syncCustomer(customer));
  }

  var _ref2$analytics = _ref2.analytics;
  _ref2$analytics = _ref2$analytics === void 0 ? {} : _ref2$analytics;
  var context = _ref2$analytics.context,
      _ref2$analytics$hasAl = _ref2$analytics.hasAlternativeContext,
      hasAlternativeContext = _ref2$analytics$hasAl === void 0 ? false : _ref2$analytics$hasAl,
      _ref2$analytics$hasEx = _ref2$analytics.hasExVat,
      hasExVat = _ref2$analytics$hasEx === void 0 ? false : _ref2$analytics$hasEx,
      quoteData = _ref2.quoteData,
      formatPrice = _ref2.formatPrice,
      formatPoints = _ref2.formatPoints,
      useClient = _ref2.useClient,
      subscribeToNewsletter = _ref2.subscribeToNewsletter,
      StoreInfoContext = _ref2.StoreInfoContext,
      customerQuery = _ref2.customerQuery,
      _ref2$quoteQuery = _ref2.quoteQuery,
      quoteQuery = _ref2$quoteQuery === void 0 ? altapayQuote : _ref2$quoteQuery,
      scriptURL = _ref2.scriptURL,
      agreement = _ref2.agreement,
      _ref2$pointPaymentId = _ref2.pointPaymentId,
      pointPaymentId = _ref2$pointPaymentId === void 0 ? "awardit" : _ref2$pointPaymentId,
      customerData = _ref2.customerData,
      PointsTooltip = _ref2.PointsTooltip,
      _ref2$vatToUse = _ref2.vatToUse,
      vatToUse = _ref2$vatToUse === void 0 ? "incVat" : _ref2$vatToUse,
      BtmColSecondaryField = _ref2.BtmColSecondaryField;
  var location = useLocation();

  var _parseParams = parseParams(location.search),
      querySessionId = _parseParams.sessionId,
      redirectData = _parseParams.redirectData;

  var t = useTranslate();
  var sendMessage = useSendMessage();
  var isFree = (quoteData == null ? void 0 : (_quoteData$data = quoteData.data) == null ? void 0 : (_quoteData$data$payme = _quoteData$data.payment) == null ? void 0 : _quoteData$data$payme.code) === "free";

  var _useHistory = useHistory(),
      push = _useHistory.push;

  var _useState2 = useState(false),
      paymentEnabled = _useState2[0],
      setPaymentEnabled = _useState2[1];

  var _useState3 = useState(isFree),
      paymentSelected = _useState3[0],
      setPaymentSelected = _useState3[1];

  var _useState4 = useState(false),
      addressIsValid = _useState4[0],
      setAddressIsValid = _useState4[1];

  var _useState5 = useState(false),
      analyticsSent = _useState5[0],
      setAnalyticsSent = _useState5[1];

  var _useState6 = useState(false),
      isEditingPoints = _useState6[0],
      _setEditingPoints = _useState6[1];

  var _useState7 = useState(false),
      isPending = _useState7[0],
      setIsPending = _useState7[1];

  var _useState8 = useState({
    terms: false,
    newsLetter: false
  }),
      state = _useState8[0],
      setState = _useState8[1];

  var errors = validation(state);
  var client = useClient();
  var availablePointPayments = quoteData && quoteData.data.availablePointPayments ? quoteData.data.availablePointPayments : null;

  var _useBrowserDimensions = useBrowserDimensions(),
      browserWidth = _useBrowserDimensions.width;

  var isDesktop = browserWidth > Number.parseInt(styles.medium, 10); // Shops that uses FB Pixel and TikTok tracking have an analyticsContext
  // locally in their repository that needs different
  // data than @crossroads/analytics

  useEffect(() => {
    var _quoteData$data2;

    if (!analyticsSent && (quoteData == null ? void 0 : (_quoteData$data2 = quoteData.data) == null ? void 0 : _quoteData$data2.items.length) > 0) {
      var modifiedQuoteData = hasAlternativeContext ? quoteData.data : quoteData.data.items;
      var vat = hasExVat ? quoteData.data.grandTotal.exVat : quoteData.data.grandTotal.incVat;
      context.registerBeginCheckoutProcess(modifiedQuoteData, vat);
      setAnalyticsSent(true);
    }
  }, [quoteData, analyticsSent, context, hasAlternativeContext, hasExVat]);
  useEffect(() => {
    if (state.terms === true && paymentSelected && addressIsValid && !isEditingPoints) {
      setPaymentEnabled(true);
    } else {
      setPaymentEnabled(false);
    }
  }, [state, paymentSelected, addressIsValid, isEditingPoints]);

  if (querySessionId && redirectData) {
    return /*#__PURE__*/React.createElement(HandleAltapayRedirect, {
      client: client,
      scriptURL: scriptURL,
      querySessionId: querySessionId,
      redirectData: redirectData
    });
  }

  if ((quoteData == null ? void 0 : (_quoteData$data3 = quoteData.data) == null ? void 0 : _quoteData$data3.items.length) === 0) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      className: styles.checkout
    }, /*#__PURE__*/React.createElement("header", {
      className: styles.checkoutHeader
    }, /*#__PURE__*/React.createElement("h1", null, t("CART.EMPTY"))));
  }

  var submit = _async(function () {
    if (subscribeToNewsletter !== null && subscribeToNewsletter !== undefined && state.newsLetter === true) {
      var _quoteData$data4;

      client(subscribeToNewsletter, {
        email: quoteData == null ? void 0 : (_quoteData$data4 = quoteData.data) == null ? void 0 : _quoteData$data4.email
      });
    }

    if (window.Altapay) {
      window.Altapay.initiatePayment();
      setTimeout(() => setIsPending(false), 2000);
    }

    return function () {
      if (isFree) {
        return _await(client(placeOrder), function (placeOrderData) {
          var _exit = false;

          function _temp(_ref3) {
            var quote = _ref3.quote;

            // Sync quote and return
            if (quote) {
              sendMessage(syncQuote(quote));
            }

            setIsPending(false);
            _exit = true;
          }

          var result = placeOrderData.placeOrder.result;
          return _invoke(function () {
            if (result !== "success") {
              sendMessage(addMessage(result, "error"));
              return _await(client(quoteQuery), _temp);
            }
          }, function (_result2) {
            return _exit ? _result2 : _invoke(_temp3, _temp4);
          }); // Sync new customer data to get the new point balance etc
        });
      }
    }();
  });

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: styles.checkout
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: t("CHECKOUT.TITLE")
  }), /*#__PURE__*/React.createElement("header", {
    className: styles.checkoutHeader
  }, /*#__PURE__*/React.createElement("h1", null, t("CHECKOUT.TITLE")), /*#__PURE__*/React.createElement(Link, {
    className: styles.back,
    to: t("URL.CHECKOUT_CART")
  }, /*#__PURE__*/React.createElement("span", null, t("CHECKOUT.BACK_TO_CART_TEXT")))), /*#__PURE__*/React.createElement("div", {
    className: styles.checkoutContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.checkoutSteps
  }, /*#__PURE__*/React.createElement(Box, {
    className: styles.checkoutStep
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.boxHeader
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.checkoutStepTitle
  }, t("CHECKOUT.ADDRESS.ADDRESS")), addressIsValid && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "link",
    size: "small",
    "aria-controls": "customerForm",
    "aria-expanded": (_addressIsValid = !addressIsValid) != null ? _addressIsValid : "true",
    onClick: () => setAddressIsValid(false)
  }, t("CHECKOUT.EDIT"))), /*#__PURE__*/React.createElement(BoxBody, {
    className: cn(styles.boxBody, {
      [styles.stepDisabled]: addressIsValid
    })
  }, /*#__PURE__*/React.createElement(CustomerForm, {
    quoteData: quoteData,
    isAddressValid: addressIsValid,
    setAddressIsValid: setAddressIsValid,
    StoreInfoContext: StoreInfoContext
  }))), availablePointPayments !== null && customerData && /*#__PURE__*/React.createElement(Box, {
    className: styles.checkoutStep
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.boxHeader
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.checkoutStepTitle
  }, t("CHECKOUT.PART_PAYMENT.HEADING")), !isEditingPoints && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "link",
    size: "small",
    onClick: () => _setEditingPoints(true)
  }, t("CHECKOUT.EDIT"))), /*#__PURE__*/React.createElement(BoxBody, {
    className: cn(styles.boxBody, {
      [styles.stepDisabled]: !isEditingPoints
    })
  }, /*#__PURE__*/React.createElement(PartPayment, {
    quoteData: quoteData,
    pointPaymentId: pointPaymentId,
    customerData: customerData,
    useClient: useClient,
    PointsTooltip: PointsTooltip,
    formatPoints: formatPoints,
    formatPrice: formatPrice,
    isEditingPoints: isEditingPoints,
    setEditingPoints: v => _setEditingPoints(v),
    vatToUse: vatToUse
  }))), !isFree && /*#__PURE__*/React.createElement(Box, {
    className: cn(styles.checkoutStep, {
      [styles.stepDisabled]: !addressIsValid || isEditingPoints
    })
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.boxHeader
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.checkoutStepTitle
  }, t("CHECKOUT.PAYMENT_METHOD_STEP"))), /*#__PURE__*/React.createElement(BoxBody, {
    className: styles.boxBody
  }, /*#__PURE__*/React.createElement(PaymentMethods, {
    isFree: isFree,
    client: client,
    setPaymentSelected: setPaymentSelected,
    customerQuery: customerQuery,
    scriptURL: scriptURL,
    storeInfoContext: StoreInfoContext
  }))), /*#__PURE__*/React.createElement(Box, {
    className: cn(styles.checkoutStep, {
      [styles.stepDisabled]: !addressIsValid || isEditingPoints
    })
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: styles.boxHeader
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.checkoutStepTitle
  }, t("CHECKOUT.PAY_STEP"))), /*#__PURE__*/React.createElement(BoxBody, {
    className: styles.boxBody
  }, /*#__PURE__*/React.createElement(OrderSummary, {
    isGrandTotalOnly: isDesktop,
    quoteData: quoteData,
    formatPrice: formatPrice,
    formatPoints: formatPoints,
    vatToUse: vatToUse
  }), /*#__PURE__*/React.createElement(Form, {
    value: state,
    errors: errors,
    className: styles.termsForm,
    onSubmit: submit,
    onChange: x => {
      setState(_extends({}, state, x));
    }
  }, subscribeToNewsletter !== null && subscribeToNewsletter !== undefined && /*#__PURE__*/React.createElement("div", {
    className: styles.newsletter
  }, /*#__PURE__*/React.createElement(CheckboxField, {
    id: "newsLetter",
    name: "newsLetter",
    value: state.newsLetter
  }, t("CHECKOUT.OPT_EMAIL"))), /*#__PURE__*/React.createElement(RenderTerms, {
    state: state,
    agreement: agreement
  })), /*#__PURE__*/React.createElement(ProceedToPayment, {
    isFree: isFree,
    isEnabled: paymentEnabled,
    isPending: isPending,
    setIsPending: setIsPending,
    submit: submit
  }))), BtmColSecondaryField !== null && BtmColSecondaryField !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: cn(styles.btmColSecOuter, styles.btmColSecSwitched)
  }, BtmColSecondaryField) : null), /*#__PURE__*/React.createElement("div", {
    className: styles.checkoutSummary
  }, /*#__PURE__*/React.createElement(Box, {
    className: styles.checkoutStep
  }, /*#__PURE__*/React.createElement(BoxHeader, {
    className: cn(styles.boxHeader)
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.checkoutSummaryTitle
  }, t("CART.SUMMARY"))), /*#__PURE__*/React.createElement(BoxBody, {
    className: styles.boxBody
  }, /*#__PURE__*/React.createElement(OrderSummary, {
    quoteData: quoteData,
    formatPrice: formatPrice,
    formatPoints: formatPoints,
    vatToUse: vatToUse
  }))), BtmColSecondaryField !== null && BtmColSecondaryField !== undefined ? /*#__PURE__*/React.createElement("div", {
    className: styles.btmColSecOuter
  }, BtmColSecondaryField) : null)));
};

export { Checkout };
//# sourceMappingURL=index.js.map
